import styled from '@emotion/styled'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  margin: auto;
  width: 565px;
`
